import { packageTypeMap } from 'stores/adapters/bex-api/search/multi-item/package-type-adapter';

import { MultiItemContext } from 'models/multi-item/multi-item-types';

import { MultiItemContextInput } from '__generated__/api';

export const mapMultiItemContextInput = (multiItemContext?: MultiItemContext): MultiItemContextInput | null => {
  if (!multiItemContext) {
    return null;
  }

  return {
    id: multiItemContext.id,
    packageType: packageTypeMap[multiItemContext.packageType],
  };
};
